import format from 'date-fns/format';

export default {
  filters: {
    dateShort(date) {
      if (!date) return '-';
      const d = new Date(date);
      return format(d, 'dd/MM');
    },

    dateFormat(date) {
      if (!date) return '-';
      const d = new Date(date);
      return format(d, 'dd/MM/yyyy');
    },

    dateFormatLong(date) {
      if (!date) return '-';
      const d = new Date(date);
      return format(d, 'eeee, do MMMM yyyy');
    },

    dateTimeFormat(date) {
      if (!date) return '-';
      const d = new Date(date);
      return format(d, 'dd/MM/yyyy, HH:mm');
    },

    dateTimeFormatLong(date) {
      if (!date) return '-';
      const d = new Date(date);
      return format(d, "eeee, do MMMM 'at' HH:mm");
    },
  },
};
